import { CustomSelectFieldProps, SelectField } from 'components/form'
import { FieldStatusContainer } from 'components/form/final-form/components/FieldStatus/FieldStatusContainer'
import { RacionalidadeEmSaudeEnum } from 'graphql/types.generated'

export type RacionalidadeEmSaudeSelectFieldProps = CustomSelectFieldProps<string> & {
  controlModifiedStatus?: boolean
}

export function RacionalidadeEmSaudeSelectField(props: RacionalidadeEmSaudeSelectFieldProps) {
  const { controlModifiedStatus = false, ...rest } = props

  const itemToString = (item: RacionalidadeEmSaudeEnum) => item && descriptions[item]

  return (
    <FieldStatusContainer controlModifiedStatus={controlModifiedStatus} name={props.name}>
      <SelectField<RacionalidadeEmSaudeSelectModel> items={items} itemToString={itemToString} {...rest} />
    </FieldStatusContainer>
  )
}

export type RacionalidadeEmSaudeSelectModel = string

const items = [
  RacionalidadeEmSaudeEnum.MEDICINA_TRADICIONAL_CHINESA,
  RacionalidadeEmSaudeEnum.ANTROPOSOFIA_APLICADA_A_SAUDE,
  RacionalidadeEmSaudeEnum.HOMEOPATIA,
  RacionalidadeEmSaudeEnum.FITOTERAPIA,
  RacionalidadeEmSaudeEnum.AYUVEDA,
  RacionalidadeEmSaudeEnum.OUTRA,
]

const descriptions = {
  MEDICINA_TRADICIONAL_CHINESA: '01 - Medicina tradicional chinesa',
  ANTROPOSOFIA_APLICADA_A_SAUDE: '02 - Antroposofia aplicada à saúde',
  HOMEOPATIA: '03 - Homeopatia',
  FITOTERAPIA: '04 - Fitoterapia',
  AYUVEDA: '05 - Ayurveda',
  OUTRA: '06 - Outra',
}
